import { getWorkersAction } from "../redux/Reducers/workersReducer";
import { BASE_URL } from "./BASE_URL";

export const getWorkers = () => {
  return async (dispatch) => {
    const response = await fetch(BASE_URL + "team/members/?limit=550");
    const data = await response.json();

    if (response.status === 200) {
      dispatch(getWorkersAction(data.results));
    }
  };
};
